// extracted by mini-css-extract-plugin
module.exports = {"anim":"forgotPasswordPending_anim__37RHl"};